import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/termsAndConditions.css';
// helpers
import {getText} from '../../../helpers/localization';
// identifiers
// actions
// configurations
import {PROMO_ASSETS_URL} from "../../../constants/endpoints";
import {ModalButton} from "./modalButton";
import {isLocalStorageAvailable} from "../../../helpers/systemHelpers";
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {OPTED_CAMPAING_IDS} from "../../../constants/localStorage";
import {openTermsAndConditions} from "../../../actions/promoBetActions";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedTCPromoId: state.vpp.selectedTCPromoId,
        promoBalances:state.vpp.promoBalances,
        systemLanguage:state.vpp.systemLanguage
    };
};

class TermsAndConditions extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            pageHtml: '',
            selectedTCPromoId: storeData.vpp.selectedTCPromoId,
            promoBalances:storeData.vpp.promoBalances,
            optInButtonShown:false,
            systemLanguage:storeData.vpp.systemLanguage,
            isScrolledToBottom:false
        };
    }

    componentDidMount() {
        let storeData = this.props.store.getState();
        if (isLocalStorageAvailable) {
            let optedInPromos= getItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS);
            if(optedInPromos !== null && optedInPromos.includes(storeData.vpp.selectedTCPromoId)){
                this.setState({optInButtonShown:false});
            }
        }
        this.state.promoBalances.map((offer) => {
            if(offer.PromoBetId === storeData.vpp.selectedTCPromoId && offer.PlayerRejectable === false) {
                this.setState({optInButtonShown:false});
            }
        });
        fetch(PROMO_ASSETS_URL + this.state.selectedTCPromoId + '/termsAndCondition_' + this.state.systemLanguage  + '.html')
            .then(response => response.text())
            .then(data => this.setState({pageHtml: data}))
            .catch((error) => console.log('Error retrieving rich text page.', error));
    }
     _getTC(e)  {
        if(!this.state.isScrolledToBottom){
            return
        }
        let storeData = this.props.store.getState();

        if (isLocalStorageAvailable) {
            let optedInPromos= getItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS);
            if(optedInPromos === null){
                optedInPromos = [];
                optedInPromos.push(storeData.vpp.selectedTCPromoId);
            }
            else if(!optedInPromos.includes(storeData.vpp.selectedTCPromoId)){
                optedInPromos.push(storeData.vpp.selectedTCPromoId);
            }
            setItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS, optedInPromos);
        }
         this.setState({optInButtonShown:false});

    }
    _closeModalPopUp()  {
        this.props.store.dispatch(openTermsAndConditions());
    }

    handleScroll() {
        let scrollElement = document.getElementById("scrollTextBox");
        if ((scrollElement.scrollTop + scrollElement.offsetHeight) >= scrollElement.scrollHeight) {
            this.setState({
                isScrolledToBottom: true
            });
        }
    }
    
    render() {
        let store = this.props.store;
        let storeData = store.getState();

        let page = (<div className={style.pageDocument} dangerouslySetInnerHTML={{__html: this.state.pageHtml}}/>);
        let button ;
        let bottomText ;
        if(this.state.optInButtonShown){
            button = (<ModalButton title = {"Opt_In"} customStyle={(this.state.isScrolledToBottom ? "" : "disableOptInButton")} onClick = {(e)=>{this._getTC()}} store={this.props.store}/>);
            bottomText=(<div className={style.clickLabel} onClick={(e)=>{this._closeModalPopUp()}}>{getText('No_Thanks', store)}</div>);
        }else{
            button = (<ModalButton title = {"Time_To_Bet"} onClick = {(e)=>{this._closeModalPopUp()}} store={this.props.store}/>);
            if (isLocalStorageAvailable) {
                let optedInPromos= getItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS);
                if(optedInPromos !== null && optedInPromos.includes(storeData.vpp.selectedTCPromoId)){
                    bottomText=getText('OPTED_IN_MSG', store);
                }
            }
        }


        return (
            <div className={style.termsAndConditionsIcon}>
                <div className={style.myOffersIconDiv}>
                    <img src={`${PROMO_ASSETS_URL}` + this.state.selectedTCPromoId + `/termsAndConditionsIcon_` + this.state.systemLanguage + `.png`} className={`${style.myOffersIcon}`}/>
                </div>
                <div className={style.textBox}>
                    <div className={style.promoHeading}>{getText('Key_Terms_Heading', this.props.store)}</div>
                    <div className={style.promoSubHeading} id={"scrollTextBox"} onScroll={(e)=> {this.handleScroll()}}>
                        {page}
                    </div>
                </div>
                {button}
                <div className={style.doNotShowText}>
                    <label className={style.label}>{bottomText}</label>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/termsAndConditions.js